import { __awaiter } from "tslib";
import { CHECK_VALUE_INTEGER, CHECK_VALUE_RANGE, CHECK_name, CHECK_FLOAT_NO_ZERO } from '@/shared/reqexp';
import { createStore } from '@souche-f2e/muji';
import { arrIsRepeat, mappingKeyToVal } from '@/shared/functions';
import Api from '@/services';
import { notification } from 'antd';
// 拍卖类型 前后端映射
const auctionType = {
    darkAuction: 'APC',
    liveAuction: 'XCP',
    carRoadAuction: 'CDP',
    superLiveAuction: 'SUPER_XCP',
    superCarRoadAuction: 'SUPER_CDP',
};
// 通用数据
const commonData = {
    currentAuctionType: 'liveAuction',
    searchData: {},
};
// 车道拍 规则数据
const carRoadAuctionData = {
    carRoadAuctionIsCanEdit: true,
    carRoadAuctionShow: false,
    carRoadAuctionEditData: {},
    carRoadAuctionConfig: [
        {
            title: '规则名称',
            keyWord: 'carRoadAuctionRuleName',
            value: '',
            isShow: true,
            unit: '',
            type: 'input',
            placeholder: '请输入规则名称',
            tips: '',
            rules: [
                { required: true, message: '请输入规则名称' },
                { validator: CHECK_name(24) },
            ],
        },
        {
            title: '单车拍卖时长',
            keyWord: 'singleCarDuration',
            value: '',
            isShow: true,
            unit: '分钟',
            type: 'input',
            placeholder: '请输入单车拍卖时长',
            tips: '最多60分钟',
            rules: [
                { required: true, message: '请输入单车拍卖时长' },
                { pattern: CHECK_VALUE_INTEGER, message: '请输入正整数' },
                { validator: CHECK_VALUE_RANGE(60) },
            ],
        },
    ],
};
// 车道拍 表格数据
const carRoadAuctionTableData = {
    carRoadAuctionTableTotal: 0,
    carRoadAuctionTableIndex: 1,
    carRoadAuctionTableSize: 20,
    carRoadAuctionTableTitle: '车道拍玩法规则',
    carRoadAuctionTableData: [],
    carRoadAuctionTableLoading: false,
};
// 超级拍-现场拍 表格数据
const superLiveAuctionTableData = {
    superLiveAuctionTableTotal: 0,
    superLiveAuctionTableIndex: 1,
    superLiveAuctionTableSize: 20,
    superLiveAuctionTableTitle: '超级拍(现场拍)玩法规则',
    superLiveAuctionTableData: [],
    superLiveAuctionTableLoading: false,
};
// 超级拍-现场拍 规则数据
const superLiveAuctionData = {
    superLiveAuctionIsCanEdit: true,
    superLiveAuctionConfig: [
        {
            title: '规则名称',
            keyWord: 'superLiveAuctionRuleName',
            value: '',
            isShow: true,
            unit: '',
            type: 'input',
            placeholder: '请输入规则名称',
            tips: '',
            rules: [
                { required: true, message: '请输入规则名称' },
                { validator: CHECK_name(24) },
            ],
        },
        {
            title: '投标时长',
            keyWord: 'superLiveBidDuration',
            value: '',
            isShow: true,
            unit: '小时',
            type: 'input',
            placeholder: '请输入投标时长',
            tips: '最多168小时',
            rules: [
                { required: true, message: '请输入投标时长' },
                { pattern: CHECK_FLOAT_NO_ZERO, message: '请输入不超过1位小数的正数(不可为0)' },
                { validator: CHECK_VALUE_RANGE(168) },
            ],
        },
        {
            title: '超级拍流拍时长',
            keyWord: 'superLiveFlowAuctionDuration',
            value: '',
            isShow: true,
            unit: '小时',
            type: 'input',
            placeholder: '请输入流拍时长',
            tips: '最多168小时',
            rules: [
                { required: true, message: '请输入流拍时长' },
                { pattern: CHECK_VALUE_INTEGER, message: '请输入正整数' },
                { validator: CHECK_VALUE_RANGE(168) },
            ],
        },
        {
            title: '投标最高价标签',
            keyWord: 'superLiveTenderMaxValNotice',
            value: 1,
            isShow: true,
            options: [{ label: '是', value: 1 }, { label: '否', value: 0 }],
            unit: '',
            type: 'radio',
            placeholder: '',
            belongsTitle: '显示标签',
            belongsTitleIndex: 0,
        },
        {
            title: '竞拍当前最高价标签',
            keyWord: 'superLiveAuctionMaxValNotice',
            value: 1,
            isShow: true,
            options: [{ label: '是', value: 1 }, { label: '否', value: 0 }],
            unit: '',
            type: 'radio',
            placeholder: '',
            belongsTitle: '显示标签',
            belongsTitleIndex: 1,
        },
        {
            title: '高于低于投标价标签',
            keyWord: 'superLiveAuctionCompareWithTenderDisplay',
            value: 1,
            isShow: true,
            options: [{ label: '是', value: 1 }, { label: '否', value: 0 }],
            unit: '',
            type: 'radio',
            placeholder: '',
            belongsTitle: '显示标签',
            belongsTitleIndex: 2,
        }
    ],
};
// 超级拍-车道拍 规则数据
const superCarRoadAuctionData = {
    superCarRoadAuctionIsCanEdit: true,
    superCarRoadAuctionConfig: [
        {
            title: '规则名称',
            keyWord: 'superCarRoadAuctionRuleName',
            value: '',
            isShow: true,
            unit: '',
            type: 'input',
            placeholder: '请输入规则名称',
            tips: '',
            rules: [
                { required: true, message: '请输入规则名称' },
                { validator: CHECK_name(24) },
            ],
        },
        {
            title: '投标时长',
            keyWord: 'superCarRoadBidDuration',
            value: '',
            isShow: true,
            unit: '小时',
            type: 'input',
            placeholder: '请输入投标时长',
            tips: '最多168小时',
            rules: [
                { required: true, message: '请输入投标时长' },
                { pattern: CHECK_FLOAT_NO_ZERO, message: '请输入不超过1位小数的正数(不可为0)' },
                { validator: CHECK_VALUE_RANGE(168) },
            ],
        },
        {
            title: '超级拍流拍时长',
            keyWord: 'superCarRoadFlowAuctionDuration',
            value: '',
            isShow: true,
            unit: '小时',
            type: 'input',
            placeholder: '请输入流拍时长',
            tips: '最多168小时',
            rules: [
                { required: true, message: '请输入流拍时长' },
                { pattern: CHECK_VALUE_INTEGER, message: '请输入正整数' },
                { validator: CHECK_VALUE_RANGE(168) },
            ],
        },
        {
            title: '单车拍卖时长',
            keyWord: 'superCarRoadSingleCarDuration',
            value: '',
            isShow: true,
            unit: '分钟',
            type: 'input',
            placeholder: '请输入单车拍卖时长',
            tips: '最多60分钟',
            rules: [
                { required: true, message: '请输入单车拍卖时长' },
                { pattern: CHECK_VALUE_INTEGER, message: '请输入正整数' },
                { validator: CHECK_VALUE_RANGE(60) },
            ],
        },
        {
            title: '投标最高价标签',
            keyWord: 'superCarRoadTenderMaxValNotice',
            value: 1,
            isShow: true,
            options: [{ label: '是', value: 1 }, { label: '否', value: 0 }],
            unit: '',
            type: 'radio',
            placeholder: '',
            belongsTitle: '显示标签',
            belongsTitleIndex: 0,
        },
        {
            title: '高于低于投标价标签',
            keyWord: 'superCarRoadAuctionCompareWithTenderDisplay',
            value: 1,
            isShow: true,
            options: [{ label: '是', value: 1 }, { label: '否', value: 0 }],
            unit: '',
            type: 'radio',
            placeholder: '',
            belongsTitle: '显示标签',
            belongsTitleIndex: 1,
        },
    ],
};
// 超级拍-车道拍 表格数据
const superCarRoadAuctionTableData = {
    superCarRoadAuctionTableTotal: 0,
    superCarRoadAuctionTableIndex: 1,
    superCarRoadAuctionTableSize: 20,
    superCarRoadAuctionTableTitle: '超级拍(车道拍)玩法规则',
    superCarRoadAuctionTableData: [],
    superCarRoadAuctionTableLoading: false,
};
// 现场拍 规则数据
const liveAuctionData = {
    liveAuctionIsCanEdit: true,
    liveAuctionShow: false,
    liveAuctionEditData: {},
    modalVisible: false,
    liveAuctionRuleName: '',
    countdownDuration: 10,
    liveAuctionConfig: [
        { title: '加价按钮1', value: '', type: 'fixedPrice' },
    ],
};
// 现场拍 表格数据
const liveAuctionTableData = {
    liveAuctionTableTotal: 0,
    liveAuctionTableIndex: 1,
    liveAuctionTableSize: 20,
    liveAuctionTableTitle: '现场拍玩法规则',
    liveAuctionTableData: [],
    liveAuctionTableLoading: false,
};
// 暗拍 规则数据
const darkAuctionData = {
    darkAuctionIsCanEdit: true,
    darkAuctionShow: false,
    darkAuctionEditData: {},
    darkAuctionConfig: [
        {
            title: '规则名称',
            keyWord: 'darkAuctionRuleName',
            value: '',
            isShow: true,
            unit: '',
            type: 'input',
            placeholder: '请输入规则名称',
            tips: '',
            rules: [
                { required: true, message: '请输入规则名称' },
                { validator: CHECK_name(24) },
            ],
        },
        {
            title: '出价次数',
            keyWord: 'bidTimes',
            value: '',
            isShow: true,
            unit: '次',
            type: 'input',
            placeholder: '请输入出价次数',
            tips: '最多10次',
            rules: [
                { required: true, message: '请输入出价次数' },
                { pattern: CHECK_VALUE_INTEGER, message: '请输入正整数' },
                { validator: CHECK_VALUE_RANGE(10) },
            ],
        },
        {
            title: '流拍时长',
            keyWord: 'flowTime',
            value: '',
            isShow: true,
            unit: '小时',
            type: 'input',
            placeholder: '请输入流拍时长',
            tips: '最多168小时',
            rules: [
                { required: true, message: '请输入流拍时长' },
                { pattern: CHECK_VALUE_INTEGER, message: '请输入正整数' },
                { validator: CHECK_VALUE_RANGE(168) },
            ],
        },
        {
            title: '最终出价排名',
            keyWord: 'finalBidPosition',
            value: 0,
            isShow: true,
            options: [{ label: '是', value: 1 }, { label: '否', value: 0 }],
            unit: '',
            type: 'radio',
            placeholder: '',
            belongsTitle: '提醒',
            belongsTitleIndex: 0,
        },
        {
            title: '成交价通知',
            keyWord: 'transactionNotice',
            value: 0,
            isShow: true,
            options: [{ label: '是', value: 1 }, { label: '否', value: 0 }],
            unit: '',
            type: 'radio',
            placeholder: '',
            belongsTitle: '提醒',
            belongsTitleIndex: 1,
        },
        {
            title: '最高价提醒',
            keyWord: 'maxPriceNotice',
            value: 1,
            isShow: true,
            options: [{ label: '是', value: 1 }, { label: '否', value: 0 }],
            unit: '',
            type: 'radio',
            placeholder: '',
            belongsTitle: '提醒',
            belongsTitleIndex: 2,
        },
        {
            title: '最高出价者以次高价成交',
            keyWord: 'highToNext',
            value: 0,
            isShow: true,
            options: [{ label: '是', value: 1 }, { label: '否', value: 0 }],
            unit: '',
            type: 'radio',
            placeholder: '',
            belongsTitle: '成交规则',
            belongsTitleIndex: 0,
        },
        {
            title: '竞拍中场次的下架功能是否开启',
            keyWord: 'downFunctionIsOn',
            value: 0,
            isShow: true,
            options: [{ label: '是', value: 1 }, { label: '否', value: 0 }],
            unit: '',
            type: 'radio',
            placeholder: '',
            belongsTitle: '成交规则',
            belongsTitleIndex: 1,
        },
        {
            title: '不超保留价是否自动流拍',
            keyWord: 'noOverAutoFailAuction',
            value: 1,
            isShow: true,
            options: [{ label: '是', value: 1 }, { label: '否', value: 0 }],
            unit: '',
            type: 'radio',
            placeholder: '',
            belongsTitle: '成交规则',
            belongsTitleIndex: 2,
        },
        {
            title: '竞拍是否冻结保证金',
            keyWord: 'auctionFreezeMargin',
            value: 1,
            isShow: true,
            options: [{ label: '是', value: 1 }, { label: '否', value: 0 }],
            unit: '',
            type: 'radio',
            placeholder: '',
            belongsTitle: '竞拍规则',
            belongsTitleIndex: 0,
        },
        {
            title: '竞拍是否允许取消报价',
            keyWord: 'auctionAllowCancelBid',
            value: 0,
            isShow: false,
            options: [{ label: '是', value: 1 }, { label: '否', value: 0 }],
            unit: '',
            type: 'radio',
            placeholder: '',
            belongsTitle: '竞拍规则',
            belongsTitleIndex: 1,
        },
    ],
};
// 暗拍 表格数据
const darkAuctionTableData = {
    darkAuctionTableTotal: 0,
    darkAuctionTableIndex: 1,
    darkAuctionTableSize: 20,
    darkAuctionTableTitle: '暗拍玩法规则',
    darkAuctionTableData: [],
    darkAuctionTableLoading: false,
};
export default createStore({
    state: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, commonData), liveAuctionData), liveAuctionTableData), darkAuctionData), darkAuctionTableData), carRoadAuctionData), carRoadAuctionTableData), superLiveAuctionData), superLiveAuctionTableData), superCarRoadAuctionData), superCarRoadAuctionTableData),
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
        // 更新数组 替换数组中的特定项
        UPDATE_ARR(state, payload) {
            state[`${state.currentAuctionType}Config`].splice(payload.index, 1, payload.tempItem);
        },
        SPLICE_ARR(state, payload) {
            state.liveAuctionConfig.splice(payload.index, 1);
        },
        PUSH_ARR(state, payload) {
            state.liveAuctionConfig.push(payload);
        },
        // 展示弹窗
        SHOW_EDIT_MODAL(state, rowData) {
            const { currentAuctionType } = state;
            state[`${currentAuctionType}Show`] = true;
            state[`${currentAuctionType}EditData`] = rowData;
        },
        // 隐藏弹窗
        HIDE_EDIT_MODAL(state) {
            const { currentAuctionType } = state;
            state[`${currentAuctionType}Show`] = false;
        },
    },
    effects: {
        // --------------------------------------------------------------- //
        // -------------------- 4期重构成可建立多个规则      ---------------  //
        // --------------------------------------------------------------- //
        // 获取/更新列表数据
        updateTable(payload, { state, update }) {
            const { currentAuctionType } = state;
            const searchParams = {
                // pageIndex: state[`${currentAuctionType}PageIndex`],
                // pageSize: state[`${currentAuctionType}PageSize`],
                auctionMode: auctionType[currentAuctionType]
            };
            Api.auction.getPlayRulesByPage(searchParams).then((res) => {
                const { items, totalNumber } = res;
                this.SET_STATE({
                    [`${currentAuctionType}TableData`]: items,
                    [`${currentAuctionType}TableTotal`]: totalNumber,
                });
            });
        },
        // 删除规则
        delRule(payload, { state, update }) {
            Api.auction.delAuctionPlayRule({ id: payload.record.id }).then((res) => {
                notification.success({ message: '规则删除成功' });
                this.updateTable({});
            });
        },
        // 设规则为默认值
        setRuleDefault(payload, { state, update }) {
            Api.auction.setDefaultPlayRule({ id: payload.record.id }).then((res) => {
                notification.success({ message: '默认规则设置成功' });
                this.updateTable({});
            });
        },
        // 根据ID获取单条消息的记录
        getAuctionPlayRuleById(payload, { state, update }) {
            Api.auction.getAuctionPlayRuleById(payload).then((res) => {
                switch (res.auctionMode) {
                    case 'XCP':
                        const tempCustomPriceBtnArr = [];
                        const customPriceButton = res.customPriceButton;
                        customPriceButton.map((item, index) => {
                            tempCustomPriceBtnArr.push({
                                title: `加价按钮${index}`,
                                value: item === '-1' ? '自定义' : item,
                                type: item === '-1' ? 'custom' : 'fixedPrice',
                            });
                        });
                        this.SET_STATE({
                            countdownDuration: res.countdownDuration,
                            liveAuctionConfig: tempCustomPriceBtnArr,
                            liveAuctionRuleName: res.ruleName,
                        });
                        break;
                    // 暗拍
                    case 'APC':
                    case 'CDP':
                    case 'SUPER_XCP':
                    case 'SUPER_CDP':
                        const tempCarRoadAuction = [
                            // 车 道 拍
                            { keyWord: 'singleCarDuration', value: res.singleCarAuctionDuration },
                            { keyWord: 'carRoadAuctionRuleName', value: res.ruleName },
                            // 暗拍
                            { keyWord: 'bidTimes', value: res.bidTimes },
                            { keyWord: 'flowTime', value: res.auctionFailedDuration },
                            { keyWord: 'finalBidPosition', value: res.bidRankRemind },
                            { keyWord: 'transactionNotice', value: res.finalPriceRemind },
                            { keyWord: 'highToNext', value: res.secondPriceDeal },
                            { keyWord: 'downFunctionIsOn', value: res.auctionTakeOff },
                            { keyWord: 'darkAuctionRuleName', value: res.ruleName },
                            { keyWord: 'maxPriceNotice', value: res.highestPriceRemind },
                            { keyWord: 'noOverAutoFailAuction', value: res.automaticAuctionFailed },
                            { keyWord: 'auctionFreezeMargin', value: res.frozenDepositTag },
                            { keyWord: 'auctionAllowCancelBid', value: res.allowCancelBid, isShow: !res.frozenDepositTag },
                            // 超级拍-现场拍 
                            { keyWord: 'superLiveAuctionRuleName', value: res.ruleName },
                            { keyWord: 'superLiveBidDuration', value: res.carAuctionDuration },
                            { keyWord: 'superLiveFlowAuctionDuration', value: res.auctionFailedDuration },
                            // 投标最高价标签 superLiveTenderMaxValNotice -- tenderHighestDisplay
                            { keyWord: 'superLiveTenderMaxValNotice', value: res.tenderHighestDisplay },
                            // 竞拍当前最高价标签 superLiveAuctionMaxValNotice -- auctionHighestDisplay
                            { keyWord: 'superLiveAuctionMaxValNotice', value: res.auctionHighestDisplay },
                            // 高于低于投标价标签 superLiveAuctionCompareWithTenderDisplay -- compareWithTenderDisplay
                            { keyWord: 'superLiveAuctionCompareWithTenderDisplay', value: res.compareWithTenderDisplay },
                            // 超级拍-车道拍
                            { keyWord: 'superCarRoadAuctionRuleName', value: res.ruleName },
                            { keyWord: 'superCarRoadBidDuration', value: res.carAuctionDuration },
                            { keyWord: 'superCarRoadFlowAuctionDuration', value: res.auctionFailedDuration },
                            // 单车拍卖时长 superCarRoadSingleCarDuration -- singleCarAuctionDuration
                            { keyWord: 'superCarRoadSingleCarDuration', value: res.singleCarAuctionDuration },
                            // 投标最高价标签 superCarRoadTenderMaxValNotice -- tenderHighestDisplay
                            { keyWord: 'superCarRoadTenderMaxValNotice', value: res.tenderHighestDisplay },
                            // 高于低于投标价标签 superCarRoadAuctionCompareWithTenderDisplay -- compareWithTenderDisplay
                            { keyWord: 'superCarRoadAuctionCompareWithTenderDisplay', value: res.compareWithTenderDisplay },
                        ];
                        tempCarRoadAuction.map((item) => {
                            this.handleItemChange(item);
                        });
                        break;
                    default:
                        return;
                }
            });
        },
        // desc 重置数据
        resetState(params) {
            this.SET_STATE(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, commonData), liveAuctionData), liveAuctionTableData), darkAuctionData), darkAuctionTableData), carRoadAuctionData), carRoadAuctionTableData), superLiveAuctionData), superLiveAuctionTableData), superCarRoadAuctionData), superCarRoadAuctionTableData));
        },
        // 清空 form
        resetForm(payload) {
            this.SET_STATE(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, liveAuctionData), darkAuctionData), carRoadAuctionData), superLiveAuctionData), superCarRoadAuctionData));
        },
        // desc 编辑/新建
        edit({ payload, callback }, { state, rootState }) {
            const { currentAuctionType } = state;
            const editData = state[`${currentAuctionType}EditData`] || {};
            const { id = '' } = editData;
            let msg = '';
            switch (currentAuctionType) {
                case 'liveAuction':
                    msg = '现场拍';
                    this.handleLiveAuctionData(payload).then((params) => {
                        if (params) {
                            Api.auction.saveOrUpdatePlayRule(Object.assign({ id }, params)).then((res) => {
                                callback && callback(res, msg);
                            });
                        }
                    });
                    break;
                case 'darkAuction':
                    msg = '暗拍';
                    this.handleDarkAuctionData(payload).then((params) => {
                        if (params) {
                            Api.auction.saveOrUpdatePlayRule(Object.assign({ id }, params)).then((res) => {
                                callback && callback(res, msg);
                            });
                        }
                    });
                    break;
                case 'carRoadAuction':
                    msg = '车道拍';
                    this.handleCarRoadAuctionData(payload).then((params) => {
                        if (params) {
                            Api.auction.saveOrUpdatePlayRule(Object.assign({ id }, params)).then((res) => {
                                callback && callback(res, msg);
                            });
                        }
                    });
                    break;
                case 'superLiveAuction':
                    msg = '超级现场拍';
                    this.handleSuperLiveAuctionData(payload).then((params) => {
                        if (params) {
                            Api.auction.saveOrUpdatePlayRule(Object.assign({ id }, params)).then((res) => {
                                callback && callback(res, msg);
                            });
                        }
                    });
                    break;
                case 'superCarRoadAuction':
                    msg = '超级车道拍';
                    this.handleSuperCarRoadAuctionData(payload).then((params) => {
                        if (params) {
                            Api.auction.saveOrUpdatePlayRule(Object.assign({ id }, params)).then((res) => {
                                callback && callback(res, msg);
                            });
                        }
                    });
                    break;
                default:
                    return;
            }
        },
        // 现场拍
        handleLiveAuctionData(payload, { state, update }) {
            return __awaiter(this, void 0, void 0, function* () {
                let params = {};
                const tempCustomPriceButton = [];
                state.liveAuctionConfig.map((item) => {
                    tempCustomPriceButton.push(item.type === 'custom' ? '-1' : item.value);
                });
                if (arrIsRepeat(tempCustomPriceButton)) {
                    notification.error({
                        message: '加价按钮不允许重复',
                    });
                    return;
                }
                params = {
                    auctionMode: 'XCP',
                    ruleName: payload.liveAuctionRuleName,
                    countdownDuration: payload.countdownDuration,
                    customPriceButton: JSON.stringify(tempCustomPriceButton),
                };
                return params;
            });
        },
        // 暗拍
        handleDarkAuctionData(payload, { state, update }) {
            return __awaiter(this, void 0, void 0, function* () {
                let params = {};
                params = {
                    auctionMode: 'APC',
                    ruleName: payload.darkAuctionRuleName,
                    bidTimes: payload.bidTimes,
                    auctionFailedDuration: payload.flowTime,
                    bidRankRemind: payload.finalBidPosition,
                    finalPriceRemind: payload.transactionNotice,
                    secondPriceDeal: payload.highToNext,
                    auctionTakeOff: payload.downFunctionIsOn,
                    maxPriceNotice: payload.maxPriceNotice,
                    noOverAutoFailAuction: payload.noOverAutoFailAuction,
                    auctionFreezeMargin: payload.auctionFreezeMargin,
                    auctionAllowCancelBid: payload.auctionAllowCancelBid,
                    highestPriceRemind: payload.maxPriceNotice,
                    automaticAuctionFailed: payload.noOverAutoFailAuction,
                    frozenDepositTag: payload.auctionFreezeMargin,
                    allowCancelBid: payload.auctionAllowCancelBid,
                };
                return params;
            });
        },
        // 车道拍
        handleCarRoadAuctionData(payload, { state, update }) {
            return __awaiter(this, void 0, void 0, function* () {
                let params = {};
                params = {
                    auctionMode: 'CDP',
                    ruleName: payload.carRoadAuctionRuleName,
                    singleCarAuctionDuration: payload.singleCarDuration,
                };
                return params;
            });
        },
        // 超级现场拍
        handleSuperLiveAuctionData(payload, { state, update }) {
            let params = {};
            params = {
                auctionMode: 'SUPER_XCP',
                ruleName: payload.superLiveAuctionRuleName,
                carAuctionDuration: payload.superLiveBidDuration,
                auctionFailedDuration: payload.superLiveFlowAuctionDuration,
                auctionHighestDisplay: payload.superLiveAuctionMaxValNotice,
                compareWithTenderDisplay: payload.superLiveAuctionCompareWithTenderDisplay,
                tenderHighestDisplay: payload.superLiveTenderMaxValNotice,
            };
            return params;
        },
        // 超级车道
        handleSuperCarRoadAuctionData(payload, { state, update }) {
            let params = {};
            params = {
                auctionMode: 'SUPER_CDP',
                ruleName: payload.superCarRoadAuctionRuleName,
                carAuctionDuration: payload.superCarRoadBidDuration,
                auctionFailedDuration: payload.superCarRoadFlowAuctionDuration,
                singleCarAuctionDuration: payload.superCarRoadSingleCarDuration,
                compareWithTenderDisplay: payload.superCarRoadAuctionCompareWithTenderDisplay,
                tenderHighestDisplay: payload.superCarRoadTenderMaxValNotice
            };
            return params;
        },
        // --------------------------------------------------------------- //
        // -------------------- 4期重构成可建立多个规则   end    ---------------  //
        // --------------------------------------------------------------- //
        // 修改拍卖类型
        changeAuctionType(payload, { state, update }) {
            return __awaiter(this, void 0, void 0, function* () {
                yield update({ currentAuctionType: payload });
            });
        },
        // 获取玩法规则信息
        getPlayRulesData(payload, { state }) {
            this.updateTable({});
        },
        // 配置项中Radio 修改
        handleChangeRadio(payload, { state, update }) {
            return __awaiter(this, void 0, void 0, function* () {
                // 暗拍 - 竞拍规则 - 竞拍是否冻结保证金 - 否
                // 展示竞拍是否允许取消报价
                const item = payload;
                if (item.keyWord !== 'auctionFreezeMargin') {
                    return;
                }
                const auctionAllowCancelBidVal = mappingKeyToVal(state.darkAuctionConfig, 'auctionAllowCancelBid');
                const tempItem = { keyWord: 'auctionAllowCancelBid', value: auctionAllowCancelBidVal, isShow: item.value === 0 };
                this.handleItemChange(tempItem);
            });
        },
        // --------------------------------------------------------------- //
        // -------------------- 暗拍 车道拍 超级拍  ------------------------  //
        // --------------------------------------------------------------- //
        // 配置项修改
        handleItemChange(payload, { state }) {
            // 当前选中的拍卖类型config数据
            const currentAuctionTypeConfig = state[`${state.currentAuctionType}Config`];
            currentAuctionTypeConfig.map((item, index) => {
                if (item.keyWord === payload.keyWord) {
                    const tempItem = Object.assign(Object.assign({}, item), payload);
                    this.UPDATE_ARR({ index, tempItem });
                }
            });
        },
        // --------------------------------------------------------------- //
        // ------------------------   现场拍  ----------------------------- //
        // --------------------------------------------------------------- //
        // 处理现场拍的修改
        handleLiveAuctionConfigChange(payload, { state }) {
            const { liveAuctionConfig } = state;
            const index = payload.index;
            const tempItem = Object.assign(Object.assign({}, liveAuctionConfig[index]), { value: payload.value });
            this.UPDATE_ARR({ index, tempItem });
        },
        // 删除特定的项目
        spliceItem(payload, { state }) {
            this.SPLICE_ARR({ index: payload.index });
        },
        // 添加项目
        addItem(payload, { state }) {
            this.PUSH_ARR(payload);
        },
        // 弹窗切换
        changeModal(payload, { state }) {
            this.SET_STATE({ modalVisible: !state.modalVisible });
        },
    },
});
